export const workData=[
    {
        company: "Dassault Systemes",
        designation: "software Development Specialist",
        datejoining: "Fab 2019",
        dateEnd: "present",
        companyLink: "https://www.3ds.com/",
        companyLogo: "https://media-exp1.licdn.com/dms/image/C560BAQHroRzeNTva6Q/company-logo_200_200/0/1519856524354?e=2159024400&v=beta&t=5PclH1EYo04-Rqk3UjH9a1vvcO-dEwQaC70IXVsc0ak",
        work: "To work with the UI Team in designing and developing the web applications using JavaScript Framework along with performance optimization in different browsers. "
    }
]